import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";
declare const Android: AndroidInterface;

export const isAndroid = (): boolean => {
  return !(typeof Android === typeof undefined);
};
